import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["nav"];

  toggle() {
    this.navTarget.classList.toggle("hidden");

    if (this.navTarget.classList.contains("hidden")) {
      document.body.classList.remove("overflow-hidden");
    } else {
      document.body.classList.add("overflow-hidden");
    }
  }
}
